<template>
  <input-field
    type="password"
    :show-password="true"
    :label="$t('authenticationPasswordLabel')"
    v-bind="$attrs"
    v-on:input="$emit('input', $event)"
  >
    <template v-slot:accessory>
      <slot name="accessory" />
    </template>
  </input-field>
</template>

<script>
  import InputField from './InputField.vue';

  export default {
    name: 'InputPasswordField',
    inheritAttrs: false,
    components: {
      InputField,
    }
  }
</script>